const genericText = {
  props: {
    selector: ".cmp-text",
    loadMoreSelector: ".cmp-text__readmore",
    loadMoreWrapperSelector: ".cmp-text__readmore--wrapper",
    cmpTextReadmore: ".cmp-text__readmore",
    readMore: ".read_more",
    readLess: ".read_less",
    hidden: "hidden",
    flagContainerSelector: ".containerFlagSelector-JS",
    flagChildSelector: ".equalHeight-JS",
  },

  init: function (baseDom = document) {
    const { selector, loadMoreSelector, flagContainerSelector, readMore, readLess } = this.props;
    const nodeList = baseDom.querySelectorAll(`${selector} ${loadMoreSelector}`);

    bcl.u.forEach(nodeList, ($item) => {
      if ($item.dataset.type == "enable" || bcl.u.mobile.isMobile()) {
        const $wrapperMore = $item.parentNode;
        const $readMore = $wrapperMore.querySelector(readMore);
        if ($readMore) {
          $readMore.addEventListener("click", () => this.loadMore($readMore));
        }

        const $readLess = $wrapperMore.querySelector(readLess);
        if ($readLess) {
          $readLess.addEventListener("click", () => this.loadLess($readLess.parentNode));
        }
      } else {
        this.loadMore($item);
      }
    });

    const nodeContainersWithFlag = baseDom.querySelectorAll(flagContainerSelector);
    if (nodeContainersWithFlag.length > 0) {
      this.checkContainers(nodeContainersWithFlag);
    }
  },

  loadMore: function ($item) {
    if ($item?.parentNode) {
      const { loadMoreWrapperSelector, hidden } = this.props;
      const $wrapper = $item.parentNode.querySelector(loadMoreWrapperSelector);
      bcl.u.removeClass($wrapper, hidden);
      bcl.u.addClass($item, hidden);
    }
  },

  loadLess: function ($item) {
    if ($item?.parentNode) {
      const { cmpTextReadmore, hidden } = this.props;
      const $wrapper = $item.parentNode.querySelector(cmpTextReadmore);
      bcl.u.removeClass($wrapper, hidden);
      bcl.u.addClass($item, hidden);
    }
  },

  checkContainers: function (containers) {
    const { flagChildSelector } = this.props;
    bcl.u.forEach(containers, ($container) => {
      const $childs = $container.querySelectorAll(flagChildSelector);
      if ($childs.length > 0) {
        this.calculateHeightChilds($childs);
      }
    });
  },

  calculateHeightChilds: function ($items) {
    let maxHeight = 0;
    bcl.u.forEach($items, ($text) => {
      maxHeight = Math.max(maxHeight, $text.offsetHeight);
    });
    this.resizeText($items, maxHeight);
  },

  resizeText: function ($items, heightValue) {
    if (heightValue > 0) {
      bcl.u.forEach($items, ($text) => {
        $text.style.height = `${heightValue}px`;
      });
    }
  },
};

export default genericText;
